import Vue from "vue";

Vue.filter("rtp", function (rate) {
  if (!isFinite(rate)) return 0;
  return parseInt(rate * 1000) / 10;
});



// WEBPACK FOOTER //
// ./src/filters/rtp.filter.js